<template>
  <div>
    <Header />
    <main>
      <div
        class="courses-page"
        :class="{ 'read-mode': $store.state.courses.readMode }"
      >
        <div class="section-frame">
          <ul class="breadcrumbs">
            <li>
              <router-link to="/"><i class="fa-home-line"></i></router-link>
            </li>
            <li><i class="fa-arrow-next"></i></li>
            <li>
              <router-link to="/courses">{{ $t("all_courses") }}</router-link>
            </li>
            <li><i class="fa-arrow-next" v-if="course"></i></li>
            <li>
              <router-link :to="`/course/${course.id}`" v-if="course"
                >{{ course.name }}
              </router-link>
            </li>
          </ul>
        </div>

        <div class="courses-main-info">
          <div class="section-frame">
            <div class="courses-main-content" v-if="course">
              <div class="page-sub-title sub-title-white courses-title">
                <div class="courses-title-star">
                  <h1>
                    <i class="fa-title"></i>
                    {{ course.name }}
                    <span class="desc-lesson">{{
                      course.lessons_count + " " + $t("lessons_count_label")
                    }}</span>
                  </h1>
                  <span class="mob-counter-lesson">{{
                    course.lessons_count + " " + $t("lessons_count_label")
                  }}</span>
                  <ul class="courses-star-title" v-if="reviews">
                    <li v-for="i in 5" :key="i">
                      <i
                        class="fa-star"
                        :class="{
                          'courses-star-active':
                            i <= Math.round(reviews.average_rate),
                        }"
                      ></i>
                    </li>
                  </ul>
                </div>
                <p>{{ course.category }}</p>
              </div>
              <div class="courses-data-frame courses-single-data-frame">
                <p class="courses-main-data">
                  <i class="fa-clock"></i> {{ $t("last_update") }}
                  {{ course.last_update }}
                </p>
                <p class="courses-main-data">
                  <i class="fa-user"></i> {{ $t("author") }}{{ course.author }}
                </p>
                <div class="courses-share">
                  <p>{{ $t("share") }}</p>
                  <ul>
                    <li>
                      <a href="#"><i class="fa-facebook"></i></a>
                    </li>
                    <li>
                      <a href="#"><i class="fa-telegram"></i></a>
                    </li>
                    <li>
                      <a href="#"><i class="fa-instagram"></i></a>
                    </li>
                    <li>
                      <a href="#"><i class="fa-vk"></i></a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div class="courses-main-content" v-else>
              <div class="page-sub-title sub-title-white courses-title">
                <div class="courses-title-star">
                  <h1>
                    <i class="fa-title"></i>
                    <div class="skeleton" style="margin: 0">
                      <div
                        class="s-line"
                        style="
                          width: 300px;
                          height: 36px;
                          display: block;
                          margin: 0;
                        "
                      ></div>
                    </div>
                    <span class="desc-lesson">
                      <div class="skeleton" style="margin: 0">
                        <div
                          class="s-line"
                          style="
                            width: 50px;
                            height: 36px;
                            display: block;
                            margin: 0;
                          "
                        ></div>
                      </div>
                    </span>
                  </h1>
                  <span class="mob-counter-lesson">
                    <div class="skeleton" style="margin: 0">
                      <div
                        class="s-line"
                        style="
                          width: 100px;
                          height: 36px;
                          display: block;
                          margin: 0;
                        "
                      ></div>
                    </div>
                  </span>
                  <ul class="courses-star-title" v-if="reviews">
                    <li v-for="i in 5" :key="i">
                      <i
                        class="fa-star"
                        :class="{
                          'courses-star-active':
                            i <= Math.round(reviews.average_rate),
                        }"
                      ></i>
                    </li>
                  </ul>
                </div>
                <p>
                  <span
                    class="skeleton"
                    style="
                      display: inline-block;
                      width: auto;
                      height: 16px;
                      margin: 0;
                    "
                  >
                    <span
                      class="s-line"
                      style="
                        width: 100px;
                        height: 16px;
                        display: inline-block;
                        margin: 0;
                      "
                    ></span>
                  </span>
                </p>
              </div>
              <div class="courses-data-frame courses-single-data-frame">
                <p class="courses-main-data">
                  <i class="fa-clock"></i>
                  Oxirgi yangilanish:
                  <span
                    class="skeleton"
                    style="
                      display: inline-block;
                      width: auto;
                      height: 16px;
                      margin: 0;
                    "
                  >
                    <span
                      class="s-line"
                      style="
                        width: 100px;
                        height: 16px;
                        display: inline-block;
                        margin: 0;
                      "
                    ></span>
                  </span>
                </p>
                <p class="courses-main-data">
                  <i class="fa-user"></i>
                  {{ $t("author") }}
                  <span
                    class="skeleton"
                    style="
                      display: inline-block;
                      width: auto;
                      height: 16px;
                      margin: 0;
                    "
                  >
                    <span
                      class="s-line"
                      style="
                        width: 100px;
                        height: 16px;
                        display: inline-block;
                        margin: 0;
                      "
                    ></span>
                  </span>
                </p>
                <div class="courses-share">
                  <p>{{ $t("share") }}</p>
                  <ul>
                    <li>
                      <a href="#"><i class="fa-facebook"></i></a>
                    </li>
                    <li>
                      <a href="#"><i class="fa-telegram"></i></a>
                    </li>
                    <li>
                      <a href="#"><i class="fa-instagram"></i></a>
                    </li>
                    <li>
                      <a href="#"><i class="fa-vk"></i></a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="courses-content">
          <div class="section-frame">
            <div class="courses-single-frame">
              <div class="courses-single-list sticky courses-lesson">
                <div class="courses-single-target">
                  <h4>{{ $t("course_content") }}</h4>
                </div>
                <div class="courses-single-link-list">
                  <div class="courses-single-link" v-if="course">
                    <div
                      v-for="top in course.material"
                      :key="top.id"
                      class="single-box"
                    >
                      <h3>{{ top.name }}</h3>
                      <ul>
                        <li
                          v-for="lesson in top.lessons"
                          :key="lesson.id"
                          :class="{
                            'single-complet-lesson single-complet':
                              lesson.process_status === 'finished',
                            active: lesson.id == $route.params.id,
                          }"
                        >
                          <router-link
                            v-if="lesson"
                            :to="`/lessons/${lesson.id}?id=${$route.query.id}`"
                          >
                            <p>
                              <svg
                                v-if="lesson.process_status === 'new'"
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  fill-rule="evenodd"
                                  clip-rule="evenodd"
                                  d="M10.75 3C10.75 2.58579 11.0858 2.25 11.5 2.25H16.5C16.9142 2.25 17.25 2.58579 17.25 3V21C17.25 21.4142 16.9142 21.75 16.5 21.75H11.5C11.0858 21.75 10.75 21.4142 10.75 21V3ZM12.25 3.75V20.25H15.75V3.75H12.25Z"
                                  fill="#CBCBDE"
                                />
                                <path
                                  fill-rule="evenodd"
                                  clip-rule="evenodd"
                                  d="M15.75 3C15.75 2.58579 16.0858 2.25 16.5 2.25H21.5C21.9142 2.25 22.25 2.58579 22.25 3V21C22.25 21.4142 21.9142 21.75 21.5 21.75H16.5C16.0858 21.75 15.75 21.4142 15.75 21V3ZM17.25 3.75V20.25H20.75V3.75H17.25Z"
                                  fill="#CBCBDE"
                                />
                                <path
                                  fill-rule="evenodd"
                                  clip-rule="evenodd"
                                  d="M3.50349 2.42778C3.54293 2.02032 3.90182 1.71975 4.30988 1.75243L9.55988 2.17289C9.7603 2.18894 9.94589 2.28479 10.075 2.43894C10.2041 2.59309 10.2659 2.79262 10.2465 2.99275L8.49651 21.0723C8.45707 21.4798 8.09819 21.7803 7.69013 21.7476L2.44013 21.3272C2.2397 21.3111 2.05412 21.2153 1.92502 21.0611C1.79592 20.907 1.73412 20.7075 1.75349 20.5073L3.50349 2.42778ZM4.92544 3.30653L3.31998 19.8929L7.07456 20.1935L8.68003 3.60722L4.92544 3.30653Z"
                                  fill="#CBCBDE"
                                />
                                <path
                                  fill-rule="evenodd"
                                  clip-rule="evenodd"
                                  d="M19 6.75C19.4142 6.75 19.75 7.08579 19.75 7.5V9C19.75 9.41421 19.4142 9.75 19 9.75C18.5858 9.75 18.25 9.41421 18.25 9V7.5C18.25 7.08579 18.5858 6.75 19 6.75Z"
                                  fill="#CBCBDE"
                                />
                                <path
                                  fill-rule="evenodd"
                                  clip-rule="evenodd"
                                  d="M14 6.75C14.4142 6.75 14.75 7.08579 14.75 7.5V9C14.75 9.41421 14.4142 9.75 14 9.75C13.5858 9.75 13.25 9.41421 13.25 9V7.5C13.25 7.08579 13.5858 6.75 14 6.75Z"
                                  fill="#CBCBDE"
                                />
                              </svg>
                              <img
                                v-if="lesson.process_status === 'progress'"
                                src="../assets/images/icon/play.svg"
                                alt=""
                              />
                              <i
                                v-if="lesson.process_status === 'finished'"
                                class="fa-check"
                              ></i>
                              <span>{{ lesson.name }}</span>
                            </p>
                            <i
                              class="fa-lock-open single-lock"
                              v-if="!lesson.is_blocked"
                            ></i>
                            <i class="fa-lock single-lock" v-else></i>
                          </router-link>
                        </li>
                        <li
                          v-if="top.quiz"
                          :class="
                            top.quiz.completed
                              ? 'single-complet single-complet-lesson'
                              : ''
                          "
                        >
                          <router-link
                            :to="`/quiz/${top.quiz.slug}?id=${$route.query.id}`"
                            v-if="top.quiz"
                          >
                            <p>
                              <i
                                class="fa-test"
                                v-if="!top.quiz.completed && !top.quiz.progress"
                              ></i>
                              <img
                                v-if="!top.quiz.completed && top.quiz.progress"
                                src="../assets/images/icon/play.svg"
                                alt=""
                              />
                              <i v-if="top.quiz.completed" class="fa-check"></i>
                              <span>{{ top.quiz.title }}</span>
                            </p>
                            <i
                              class="fa-lock-open single-lock"
                              v-if="!top.quiz.is_blocked"
                            ></i>
                            <i class="fa-lock single-lock" v-else></i>
                          </router-link>
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div class="courses-single-link skeleton" v-else>
                    <div v-for="key in 5" :key="key" class="single-box">
                      <h3>
                        <span
                          class="s-line"
                          style="width: 100%; display: block"
                        ></span>
                      </h3>
                      <ul>
                        <li v-for="key in 5" :key="key">
                          <span
                            class="s-line"
                            style="width: 100%; display: block"
                          ></span>
                        </li>
                      </ul>
                    </div>
                  </div>
                  <router-link
                    v-if="course && course.final_quiz"
                    :to="`/final-quiz/${course.final_quiz.slug}?id=${$route.query.id}`"
                    class="single-test-btn"
                  >
                    <i
                      class="fa-test"
                      v-if="
                        !course.final_quiz.completed &&
                        !course.final_quiz.progress
                      "
                    ></i>
                    <img
                      v-if="
                        !course.final_quiz.completed &&
                        course.final_quiz.progress
                      "
                      src="../assets/images/icon/play.svg"
                      alt=""
                    />
                    <i v-if="course.final_quiz.completed" class="fa-check"></i>
                    <div>{{ $t("final_test") }}</div>
                    <i
                      v-if="course.final_quiz.is_blocked"
                      class="fa-lock single-test-lock"
                    ></i>
                    <i v-else class="fa-lock-open single-test-lock"></i>
                  </router-link>
                </div>
              </div>
              <router-view></router-view>
            </div>
          </div>
        </div>
      </div>
    </main>
    <MobileBar @active="popupUser" />
    <PopupUser @active="popupUser" :active="active" />
    <Footer />
  </div>
</template>

<script>
import Header from "@/components/Header";
import MobileBar from "@/components/MobileBar";
import Footer from "@/components/Footer";
import PopupUser from "@/components/PopupUser";

export default {
  data() {
    return {
      active: false,
    };
  },
  async created() {
    await this.$store.dispatch("getReviewsById", {
      id: this.$route.query.id,
      page: 1,
    });
  },
  methods: {
    popupUser(e) {
      this.active = e;
    },
  },
  computed: {
    course() {
      return this.$store.getters.getCourse;
    },
    reviews() {
      return this.$store.getters.getReviews;
    },
  },
  components: {
    Header,
    MobileBar,
    Footer,
    PopupUser,
  },
};
</script>
